import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { GetSpaceResponseDto } from './dto/response/get-space-response.dto';

const RESOURCE_PATH = HttpPathsEnum.RESOURCE;

class SpacesManagementApi {
  public async getSpaces(scope?: number) {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/space`,
      method: RequestType.GET,
      params: {
        scope: scope ? scope : undefined,
      },
    };

    return await AppHttpClient.exec<any, GetSpaceResponseDto[]>(
      request,
      GetSpaceResponseDto
    );
  }

  public async getCompanySpaces() {
    const request: HttpRequest = {
      url: `${RESOURCE_PATH}/space/spaces-by-company/my-company`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetSpaceResponseDto[]>(
      request,
      GetSpaceResponseDto
    );
  }
}

export default new SpacesManagementApi();
